import { render, staticRenderFns } from "./InternationDrawer.vue?vue&type=template&id=20b63efc&scoped=true&"
import script from "./InternationDrawer.vue?vue&type=script&lang=js&"
export * from "./InternationDrawer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20b63efc",
  null
  
)

export default component.exports